import { Portal } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { OuiSlidePanelService } from 'omnium-ui/layout';
import { BehaviorSubject, Observable, filter, map, tap } from 'rxjs';
import { FileMetadata, StorageFile } from '../../../models/generated/graphql';

export type DocumentViewerInfo = {
  viewerType: 'custom' | 'simple' | 'appended-file';
  storageFile?: StorageFile;
  fileMetadata?: FileMetadata;
  commentaire?: string;
  documentUrl?: string;
  customPortal?: Portal<any>;
  ficheConseilInfo?: any;
};

export type SimpleDocumentViewerInfo = {
  storageFile?: StorageFile;
};

@Injectable({
  providedIn: 'root',
})
export class DocumentViewerService {
  private _fileViewerInfoSubject = new BehaviorSubject<DocumentViewerInfo | null>(null);
  public readonly fileViewerInfo$ = this._fileViewerInfoSubject.asObservable();

  public readonly viewerClosed$: Observable<void>;

  private opened: boolean = false;

  slidePanelContent?: Portal<any>;
  customSlidePanelContent?: Portal<any>;

  constructor(private slidePanelService: OuiSlidePanelService) {
    this.viewerClosed$ = this.slidePanelService.slidePanelState$.pipe(
      filter(state => state === 'closed' && this.opened),
      tap(() => this.onPanelClose()),
      map(() => {})
    );
  }

  public setDocumentViewerPortal(portal: Portal<any>) {
    this.slidePanelContent = portal;
  }

  private openDocumentViewer() {
    if (!this.slidePanelContent) {
      throw "Impossible d'ouvrir le document viewer : portal non défini. Définissez le à l'aide de la méthode setDocumentViewerPortal.";
    }

    this.slidePanelService.setSlidePanelContent(this.slidePanelContent);
    this.slidePanelService.openSlidePanel({ position: 'right', autoFocus: false, disableClose: false });

    this.opened = true;
  }


  public closeDocumentViewer() {
    this.slidePanelService.setSlidePanelContent(null);
    this.slidePanelService.closeSlidePanel();
  }

  private onPanelClose() {
    this.opened = false;
  }

  public openSimpleDocumentViewer(fileInfo: SimpleDocumentViewerInfo, ficheConseilInfo?: any): void {
    this._fileViewerInfoSubject.next({
      viewerType: 'simple',
      storageFile: fileInfo.storageFile,
      documentUrl: fileInfo.storageFile?.fileConnectionInfo?.sasUrl,
      ficheConseilInfo: ficheConseilInfo,
    });

    this.openDocumentViewer();
  }
}
